
enum EnvironmentTypes {
    local,
    dev,
    qa,
    sandbox,
    staging,
    prod
};

export interface IHeaderSettings {
    nonexpandedHeight: string
    expandedHeight: string
    environmentBarHeight: number
    navBarHeight: number
    units: string
};

function HeaderSettings(): IHeaderSettings {
    const headerSettings: IHeaderSettings = {
        nonexpandedHeight: "5.75em",
        expandedHeight: "8.75em",
        environmentBarHeight: 50,
        navBarHeight: 72,
        units: "px"
    };

    return headerSettings;
}


export { EnvironmentTypes, HeaderSettings };